import { Input} from 'reactstrap';
import './select.scss'

const Select = (props: any) => {
    const {children, value, autoFocus, ...rest} = props

    const getSelectClass = (): string => {
        if (!value || value === '0') {
            return 'select-placeholder'
        }
        return 'select-default'
    }

	return (
        <Input type="select"
            className={getSelectClass()}
            value={value}
            autoFocus={autoFocus} 
            {...rest}>
           {children}
        </Input>
    )
}

export default Select

